module.exports = __webpack_public_path__ + "static/media/native-english-speaker.bcaec08d.jpg";